import { CALL_INTAKE_API } from "middleware/intakeApi";

export const SEND_MAINTENANCE_OBJECTION_REQUEST = 'SEND_MAINTENANCE_OBJECTION_REQUEST';
export const SEND_MAINTENANCE_OBJECTION_SUCCESS = 'SEND_MAINTENANCE_OBJECTION_SUCCESS';
export const SEND_MAINTENANCE_OBJECTION_FAILURE = 'SEND_MAINTENANCE_OBJECTION_FAILURE';

export const sendMaintencanceObjection = () => {
  return {
    [CALL_INTAKE_API]: {
      types: [SEND_MAINTENANCE_OBJECTION_REQUEST, SEND_MAINTENANCE_OBJECTION_SUCCESS, SEND_MAINTENANCE_OBJECTION_FAILURE],
      authenticated: true,
      endpoint: 'intakeMaintenance/objection',
      method: 'GET',
    },
  };
};